import { action } from 'satcheljs';
import { HostedApp } from '../store/schema/AppHostStore';

export const onOpenMOSAppWithContext = action(
    'onOpenMOSAppWithContext',
    (appId: string, app: HostedApp, entityId: string, subEntityId: string) => ({
        appId,
        app,
        entityId,
        subEntityId,
    })
);
